import RsaGestioneAmbulatorialeListPage from "./pages/RsaGestioneAmbulatorialeListPage.vue";

export default {
	RsaGestioneAmbulatorialeListPage,
};
